import React from 'react'
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SummaryView from '../SummaryView/SummaryView';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(14),
      // fontWeight: theme.typography.fontWeightBold,
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      border: 'solid 1px rgba(0, 0, 0, 0.12)',
      borderRadius: '8px',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
)
interface AccordionSummaryViewProps {
  summary: string[]
  expanded: boolean
}

export default function AccordionSummaryView(props: AccordionSummaryViewProps) {
  const { summary = [] } = props
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Accordion defaultExpanded={props.expanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Summary</Typography>
        </AccordionSummary>
        <AccordionDetails className="flex-column">
          <SummaryView summary={summary}></SummaryView>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
